export interface IosHealthFields {
  iosAuthorization?: IosAuthorization;
  iosAlertStyle?: IosAlertStyle;
  iosSound?: boolean;
  iosLockScreen?: boolean;
  iosNotificationCenter?: boolean;
  iosTimeSensitive?: boolean;
  iosScheduledSummary?: boolean;
}

export type IosAuthorization =
  | 'authorized'
  | 'provisional'
  | 'ephemeral'
  | 'denied'
  | 'notDetermined';
export type IosAlertStyle = 'none' | 'banner' | 'alert';
type IosSetting = 'enabled' | 'disabled' | 'notSupported' | 'unknown';

export interface IosNotificationSettings {
  authorization: IosAuthorization | 'unknown';
  alertStyle: IosAlertStyle | 'unknown';
  sound: IosSetting;
  lockScreen: IosSetting;
  notificationCenter: IosSetting;
  timeSensitive: IosSetting;
  scheduledDelivery: IosSetting;
}

function settingFlag(value: IosSetting): boolean | undefined {
  if (value === 'enabled') return true;
  if (value === 'disabled') return false;
  return undefined;
}

export function iosHealthFields(settings: IosNotificationSettings): IosHealthFields {
  const fields: IosHealthFields = {
    iosSound: settingFlag(settings.sound),
    iosLockScreen: settingFlag(settings.lockScreen),
    iosNotificationCenter: settingFlag(settings.notificationCenter),
    iosTimeSensitive: settingFlag(settings.timeSensitive),
    iosScheduledSummary: settingFlag(settings.scheduledDelivery),
  };
  if (settings.authorization !== 'unknown') fields.iosAuthorization = settings.authorization;
  if (settings.alertStyle !== 'unknown') fields.iosAlertStyle = settings.alertStyle;
  return Object.fromEntries(
    Object.entries(fields).filter(([, value]) => value !== undefined),
  ) as IosHealthFields;
}
